
<template>
  <div
      @dragenter.prevent="toggleActive"
      @dragleave.prevent="toggleActive"
      @dragover.prevent
      @drop.prevent="toggleActive"
      :class="{ 'active-dropzone': active }"
      class="dropzone"
  >
    <span>Arraste ou solte aqui os arquivos</span>
    <span>OU</span>
    <label for="dropzoneFiles">Clique aqui e selecione os arquivos</label>
    <input type="file" multiple="multiple" id="dropzoneFiles" class="dropzoneFiles btn btn-primary" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.xml"/>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "dropzone",
  setup() {
    const active = ref(false);
    const toggleActive = () => {
      active.value = !active.value;
    };
    return { active, toggleActive };
  },
};
</script>

<style scoped lang="scss">
.dropzone {
  // width: 400px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
  border: 2px dashed #41b883;
  background-color: #fff;
  transition: 0.3s ease all;
  label {
    padding: 8px 12px;
    color: #fff;
    background-color: #41b883;
    transition: 0.3s ease all;
  }
  input {
    display: none;
  }
}
.active-dropzone {
  color: #fff;
  border-color: #fff;
  background-color: #41b883;
  label {
    background-color: #fff;
    color: #41b883;
  }
}
</style>
